import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Menu from '@zacousticrepo/grommet-v1-custom/components/Menu';
import Anchor from '@zacousticrepo/grommet-v1-custom/components/Anchor';
import SupportIcon from '../icons/SupportIcon';
import SettingIcon from '../icons/SettingIcon';
import TeamIcon from '../icons/TeamIcon';

import DateRangeIcon from "@material-ui/icons/DateRange";
import SupportAgentIcon from '@material-ui/icons/LocalLibrary';

import { logout } from '../sessionActions';
import { checkPrivledges, getProfilePictureNode } from '../utils';
import { ZacousticPermission, FileType } from '../generated';

class SessionMenu extends Component {
    constructor() {
        super();
        this.profilePictureType = FileType.Resized_60_60;
        this._onLogout = this._onLogout.bind(this);
        this.goToSupport = this.goToKnowledgeBase.bind(this);
        this.goToCustomerPortal = this.goToCustomerPortal.bind(this);
    }

    _onLogout(event) {
        const { session } = this.props;
        event.preventDefault();
        this.props.dispatch(logout(session));
    }

    goToKnowledgeBase(event) {
        event.preventDefault();
        window.open("https://support.zacoustic.com/", "_blank").focus();
    }

    goToCustomerPortal(event) {
        event.preventDefault();
        window.open("https://support.zacoustic.com/tickets-view", "_blank").focus();
    }

    render() {
        const {
            dropAlign,
            colorIndex,
            session: { name: userName, userId, currentUser }
        } = this.props;

        const avatarIcon = getProfilePictureNode(currentUser, this.profilePictureType);
        //const settingIcon = <SupportAgentIcon fontSize="large" />;
        const settingIcon = <SettingIcon />
        const supportIcon = <SupportIcon />;
        const teamIcon = <TeamIcon />;

        return (<div style={{ marginLeft: '25px' }}>
            <div className="title-text-secandary-600-14-16">{currentUser ? currentUser.Name : ''}</div>
            {/* <div>{currentUser ? currentUser.UserName : ''}</div> */}
            <hr style={{ borderTopWidth: '4px', margin: '5px 0' }} />
            <Menu icon={avatarIcon} dropAlign={dropAlign} colorIndex={colorIndex} a11yTitle="Session">
                <Anchor href="#" tag="h3" onClick={this._onLogout} label="Logout" />
            </Menu>
            <Menu icon={teamIcon} dropAlign={dropAlign} colorIndex={colorIndex} a11yTitle="Session">
                <Anchor href="#" tag="h4" onClick={this.goToCustomerPortal} label="Customer Portal" />
            </Menu>
            <Menu icon={supportIcon} dropAlign={dropAlign} colorIndex={colorIndex} a11yTitle="Session">
                <Anchor href="#" tag="h4" onClick={this.goToKnowledgeBase} label="Knowledge Base" />
            </Menu>
        </div>
        );
    }
}

SessionMenu.propTypes = {
    colorIndex: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    dropAlign: Menu.propTypes.dropAlign,
    session: PropTypes.object.isRequired
};

const select = state => ({ session: state.session });

export default connect(select)(SessionMenu);
